<script>
    import { classNames } from "../../utils";
    let cls = "sui-safe-area";
    // 'top' | 'bottom'
    export let position = "";
</script>

<div
    class={classNames({
        [cls]: cls,
        [`${cls}-${position}`]: position,
    })}
/>

<style lang="less">
    @import "./safeArea.less";
</style>
